var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5',{attrs:{"id":"msg-no-fatture"}},[_vm._v("Non ci sono fatture corrispondenti ai parametri di ricerca impostati")])
}
var staticRenderFns = []

export { render, staticRenderFns }